import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cta" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"cta__container inner\"><div class=\"cta-avatar2\"></div><h2 class=\"cta__ttl\"> 「楽しく学ぶ」を、BLOCKVROCKで。 <br>個人利用は無料です。 <br class=\"is-sp\">今すぐ体験してください。 </h2><a class=\"cta__button mv__button\" href=\"./account_register\" target=\"_blank\">今すぐ無料で体験する</a><div class=\"cta-avatar1\"></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}